/* @flow */
// typecheck: ignore file
import _ from 'lodash';
import cx from 'classnames';
import React from 'react';

import createChainedFunction from 'utils/createChainedFunction';
import { mountModal } from 'lib/modal';

import styles from './styles/ModalTrigger.css';

class ModalTrigger extends React.Component {
  props: {
    modal: React$Element<*>,
    children?: React$Element<*>, // Flow issue facebook/flow#1355
    className?: string,
  };

  handleClick = (event: SyntheticEvent) => {
    event.preventDefault();

    mountModal(this.props.modal, this);
  };

  render() {
    const { children, className, ...others } = this.props;
    const child = React.Children.only(children);

    const childProps = Object.assign(_.omit(others, ['modal']), {
      className: cx(styles.this, child.props.className, className),
      onClick: createChainedFunction(this.handleClick, child.props.onClick),
    });

    return React.cloneElement(child, childProps);
  }
}

export default ModalTrigger;



// WEBPACK FOOTER //
// ./src/components/ModalTrigger.jsx